import { render, staticRenderFns } from "./PastDueWizardFlow.vue?vue&type=template&id=453b48f2&scoped=true&"
import script from "./PastDueWizardFlow.vue?vue&type=script&lang=js&"
export * from "./PastDueWizardFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453b48f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('453b48f2')) {
      api.createRecord('453b48f2', component.options)
    } else {
      api.reload('453b48f2', component.options)
    }
    module.hot.accept("./PastDueWizardFlow.vue?vue&type=template&id=453b48f2&scoped=true&", function () {
      api.rerender('453b48f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/pastduewizard/PastDueWizardFlow.vue"
export default component.exports